export const primary_key = 'cost-center' as const;

/**
 * @example
 *  - ['cost-center']
 *  - ['cost-center', 'list', <filters>]
 *  - ['cost-center', 'detail', <id>]
 */
const CostCenterQueryKeys = {
  all: () => [primary_key] as const,
  list: (filters?: Record<string, unknown>) =>
    [
      ...CostCenterQueryKeys.all(),
      'list',
      ...(filters ? [filters] : [])
    ] as const,
  detail: (id: number) => [...CostCenterQueryKeys.all(), 'detail', id] as const
};

export default CostCenterQueryKeys;
